import {ITableColumn} from '../../types';
import {ReactNode} from 'react';
import {SubscriptionItem} from "../subscription-items/types.ts";

export type SubscriptionDimension = { name: string, value: string }

export enum SubscriptionStatus {
    incomplete = 'incomplete',
    incomplete_expired = 'incomplete_expired',
    trialing = 'trialing',
    active = 'active',
    past_due = 'past_due',
    canceled = 'canceled',
    unpaid = 'unpaid',
    paused = 'paused'
}


export type Subscription = {
    id: string,
    cancelAt?: number,
    canceledAt?: number,
    customerId?: string,
    description?: string,
    currency?: string,
    endedAt?: number,
    items?: SubscriptionItem[],
    startDate: number,
    status?: SubscriptionStatus,
    trialEnd?: number,
    trialStart?: number,

    created: number,
    updated?: number,

    // FNP-918: DERIVED, not part of the GraphQL schema.
    //
    // Stripe returns `created` and `startDate` as UNIX epochs in SECONDS.
    // useSubscriptions normalises both to milliseconds once, so the table's
    // Created / Start Date columns can render AND sort the same value — a
    // column that displays one unit and sorts another drifts silently.
    createdAtMillis?: number,
    startDateMillis?: number,
}


export interface ISubscriptionTableColumn extends ITableColumn {
    render?: (item: Subscription) => ReactNode;
}


export type ListSubscriptions = {
    listSubscriptions: { items: Subscription[], nextToken?: string }
}

export type GetSubscription = {
    getSubscription: Subscription
}

export type CreateSubscription = {
    createSubscription: Subscription
}

export type UpdateSubscription = {
    updateSubscription: Subscription
}

export type DeleteSubscription = {
    deleteSubscription: string
}

